import { useEffect, useMemo, useState } from 'react';
import AppSelect from '../../../../components/form/base/app-select';
import { apiService } from '../../../../services/api.service';
import { LabelValue } from '../../../../types/label-value.types';
import { useSelector } from 'react-redux';
import { AppStore } from '../../../../store/store';
import { UserState } from '../../../../store/user.slice';
import AppDatePicker from '../../../../components/form/base/app-datepicker';
import dayjs, { Dayjs } from 'dayjs';
import dateService from '../../../../services/date.service';
import { StatusType } from '../../../../types/statistics.types';
import TableContent from '../../../../components/table-content';
import TablePagination from '../../../../components/table-pagination';
import { ReactComponent as CardIcon } from '../../../../assets/icons/processor-card.svg'
import { ReactComponent as UserIcon } from '../../../../assets/icons/user.svg';
import { ReactComponent as MerchantIcon } from '../../../../assets/icons/merchant.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/icons/delete.svg';
import { formatAmount } from '../../../../utils/number-utils';
import { ApiPageInfo, CommissionApiResponse, TransactionFilters } from '../../../../services/api.service-types';
import AppCheckboxInput from '../../../../components/form/base/app-checkbox-input';
import Button from '../../../../components/button';
import './generate-settlement-page.scss';
import Modal from '../../../../components/modal';
import AddCustomTransactionsModal from './add-custom-transactions-modal';
import { CustomTransaction } from '../../../../types/transaction.types';
import { CommissionType } from '../../merchants/edit-mid/edit-mid.types';
import { errorService } from '../../../../services/error.service';
import LoadingSpinner from '../../../../components/loading-spinner';
import AppTimePicker from '../../../../components/form/base/app-time-picker';
import AppFormElementContainer from '../../../../components/form/base/app-form-element-container';
import AppFormElementLabel from '../../../../components/form/base/app-form-element-label';


const GenerateSettlementPage = () => {

    const { user } = useSelector<AppStore, UserState>((state) => state.user)

    const [selectedFromDate, setSelectedFromDate] = useState<Dayjs | null>();
    const [selectedFromTime, setSelectedFromTime] = useState<string | null>('00:00');
    const [selectedToDate, setSelectedToDate] = useState<Dayjs | null>();
    const [selectedToTime, setSelectedToTime] = useState<string | null>('00:00');

    const [merchantOptions, setMerchantOptions] = useState<LabelValue[]>([]);

    const [commissions, setCommissions] = useState<CommissionApiResponse[]>([]);

    const [selectedMerchant, setSelectedMerchant] = useState('');

    const [midOptions, setMidOptions] = useState<LabelValue[]>([]);
    const [selectedMID, setSelectedMID] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalElements, setTotalElements] = useState(0);

    const [transactionsForSettle, setTransactionsForSettle] = useState([]);
    const [transactionsLoader, setTransactionsLoader] = useState(false);
    const [excludedTransactions, setExcludedTransactions] = useState<string[]>([]);

    const [addedTransactions, setAddedTransactions] = useState<CustomTransaction[]>([]);

    const [addTransactionsModal, setAddTransactionModal] = useState(false);

    const [removeTransactionModal, setRemoveTransactionModal] = useState(false);
    const [removeTransactionId, setRemoveTransactionId] = useState<string>();

    const [isDownloading, setIsDownloading] = useState(false);

    const columnsTransactions = [
        {
            Header: 'Trace ID',
            accessor: 'id',
            Cell: ({ value }: { value: string }) => (
                <div>
                    <span
                    >{value}</span>
                </div>
            ),
        },
        {
            Header: 'Customer',
            accessor: 'customerName',
            Cell: ({ value, row }: { value: string; row: any }) => (
                <div className="flex-column flex-gap-5">
                    <div className="flex-row flex-gap-5 flex-align-start-center">
                        <UserIcon />
                        <span>{value}</span>
                    </div>
                    <div className="secondary-text accent-gradient-text">
                        {row.original.customerCardType} xxxx xxxx xxxx {row.original.customerLastFourCardDigits}
                    </div>
                </div>
            ),
        },
        {
            Header: 'Merchant',
            accessor: 'merchantName',
            Cell: ({ value, row }: { value: string; row: any }) => (
                <div className="flex-column flex-gap-5">
                    <div className="flex-row flex-gap-5 flex-align-start-center">
                        <MerchantIcon />
                        <span>{value}</span>
                    </div>
                    <div className="secondary-text accent-gradient-text">{row.original.transactionReferenceCode}</div>
                </div>
            ),
        },
        {
            Header: 'Channel',
            accessor: 'processorName',
            Cell: ({ value, row }: { value: string; row: any }) => (

                <div className="flex-column flex-gap-5">
                    <div className="flex-row flex-gap-5 flex-align-start-center">
                        <CardIcon />
                        <span>{value}</span>
                    </div>
                    <div className="secondary-text accent-gradient-text">
                        {row.original.processorTransactionId}
                    </div>
                </div>
            ),
        },
        {
            Header: 'Value',
            accessor: 'amount',
            Cell: ({ value }: { value: string }) =>
                <span className="value-text accent-gradient-text">${formatAmount(+value)}</span>
        },
        {
            Header: () => (
                <div className='flex-row flex-align-center-center'>
                    Status
                </div>
            ),
            accessor: 'status',
            Cell: ({ value, row }: { value: string; row: any }) => {


                return (
                    <div className='flex-row flex-align-center-center width-100'>
                        <div
                            className={`status ${value?.toLowerCase()} flex-row flex-align-center-center`}
                        >
                            <span
                            >{value}</span>
                        </div>

                    </div>
                );
            },
        },
        {
            Header: () => (
                <div className='flex-row flex-align-center-center'>
                    Time
                </div>
            ),
            accessor: 'date',
            Cell: ({ value }: { value: string }) =>
                <div className="date-text">{dateService.formatDateForTable(value)}</div>
        },

        {
            Header: 'Exclude',
            accessor: 'allowedActions',
            Cell: ({ row }: { value: string[]; row: any }) => {
                const included = excludedTransactions?.includes(row.original.id) || false;

                return (
                    <div className='checkbox-column flex-row flex-align-center-center width-100'>
                        <AppCheckboxInput
                            id={row.original.id}
                            label=''
                            checked={included}
                            onChange={(event) => {
                                console.log(event);

                                setExcludedTransactions(prev => {
                                    if (!prev) return [row.original.id];
                                    if (prev.includes(row.original.id)) {
                                        return prev.filter(id => id !== row.original.id);
                                    }
                                    return [...prev, row.original.id];
                                })
                            }}
                        />
                    </div>
                )
            },
        },
    ];

    const columnAddedTransactions = [
        {
            Header: 'Trace ID',
            accessor: 'id',
            Cell: ({ value }: { value: string }) => (
                <div>
                    <span
                    >{value}</span>
                </div>
            ),
        },
        {
            Header: 'Customer',
            accessor: 'customerName',
            Cell: ({ value, row }: { value: string; row: any }) => (
                <div className="flex-column flex-gap-5">
                    <div className="flex-row flex-gap-5 flex-align-start-center">
                        <UserIcon />
                        <span>{value}</span>
                    </div>
                    <div className="secondary-text accent-gradient-text">
                        {row.original.customerCardType} xxxx xxxx xxxx {row.original.customerLastFourCardDigits}
                    </div>
                </div>
            ),
        },
        {
            Header: 'Merchant',
            accessor: 'merchantName',
            Cell: ({ value, row }: { value: string; row: any }) => (
                <div className="flex-column flex-gap-5">
                    <div className="flex-row flex-gap-5 flex-align-start-center">
                        <MerchantIcon />
                        <span>{value}</span>
                    </div>
                    <div className="secondary-text accent-gradient-text">{row.original.transactionReferenceCode}</div>
                </div>
            ),
        },
        {
            Header: 'Channel',
            accessor: 'processorName',
            Cell: ({ value, row }: { value: string; row: any }) => (

                <div className="flex-column flex-gap-5">
                    <div className="flex-row flex-gap-5 flex-align-start-center">
                        <CardIcon />
                        <span>{value}</span>
                    </div>
                    <div className="secondary-text accent-gradient-text">
                        {row.original.processorTransactionId}
                    </div>
                </div>
            ),
        },
        {
            Header: 'Value',
            accessor: 'amount',
            Cell: ({ value }: { value: string }) =>
                <span className="value-text accent-gradient-text">${formatAmount(+value)}</span>
        },
        {
            Header: () => (
                <div className='flex-row flex-align-center-center'>
                    Status
                </div>
            ),
            accessor: 'status',
            Cell: ({ value, row }: { value: string; row: any }) => {


                return (
                    <div className='flex-row flex-align-center-center width-100'>
                        <div
                            className={`status ${value?.toLowerCase()} flex-row flex-align-center-center`}
                        >
                            <span
                            >{value}</span>
                        </div>

                    </div>
                );
            },
        },
        {
            Header: () => (
                <div className='flex-row flex-align-center-center'>
                    Time
                </div>
            ),
            accessor: 'date',
            Cell: ({ value }: { value: string }) =>
                <div className="date-text">{dateService.formatDateForTable(value)}</div>
        },
        {
            Header: 'Selected Fee',
            accessor: 'selectedFee',
            Cell: ({ value, row }: { value: string, row: any }) => {
                return (
                    <div className="select-fee">
                        <AppSelect
                            value={value}
                            options={commissionsOptions}
                            onChange={(newValue) => {
                                setAddedTransactions(prev =>
                                    prev.map(t =>
                                        t.id === row.original.id
                                            ? { ...t, selectedFee: newValue as CommissionType }
                                            : t
                                    )
                                );
                            }}
                        />
                    </div>)
            }
        },
        {
            Header: 'Remove',
            accessor: '',
            Cell: ({ row }: { row: any }) => {
                return (
                    <div className=''>
                        <DeleteIcon
                            className='pointer'
                            onClick={() => {
                                setRemoveTransactionModal(true);
                                setRemoveTransactionId(row.original.id);
                            }}
                        />
                    </div>
                )
            },
        },
    ];

    const commissionsOptions = useMemo(() => {
        return commissions.map((commission: CommissionApiResponse) => ({
            label: `${commission.commissionType} - ${commission.isPercent ? `${commission.commissionAmount}%` : `$${commission.commissionAmount}`} `,
            value: commission.id,
        }));
    }, [commissions])

    useEffect(() => {
        apiService
            .getAllMerchants()
            .then((response) => {
                const transformedMerchants = response.data.map((merchant: any) => ({
                    label: merchant.lastName || merchant.lastName || 'Unknown',
                    value: merchant.id,
                }));
                setMerchantOptions([{
                    label: 'Reset',
                    value: '',
                }, ...transformedMerchants]);
            })
            .catch((error) => console.error('Error fetching merchants:', error));


    }, [user])

    useEffect(() => {

        if (selectedFromDate && selectedToDate && selectedMerchant && selectedMID && selectedToTime && selectedFromTime) {

            const pageInfo = {
                page: currentPage - 1,
                size: 10
            }

            setTransactionsLoader(true)
            apiService.getTransactionsListForSettlement({
                startDate: dateService.formatDateTime(selectedFromDate, selectedFromTime),
                endDate: dateService.formatDateTime(selectedToDate, selectedToTime),
                merchantId: selectedMerchant,
                midId: selectedMID,
                statuses: [StatusType.APPROVED, StatusType.DECLINED]
            }, pageInfo)
                .then((response) => {
                    setExcludedTransactions([])
                    setTransactionsForSettle(response.data.content)
                    setTotalPages(response.data.totalPages)
                    setTotalElements(response.data.totalElements)
                    console.log(response);
                })
                .catch((error) => console.log(error))
                .finally(() => setTransactionsLoader(false))
        }

    }, [user, selectedFromDate, selectedToDate, selectedMerchant, selectedMID, selectedToTime, selectedFromTime])

    const handleGetMids = async (value: string) => {
        try {
            const response = await apiService.getMidsByMerchantAndProcessor({ merchantId: value, processorId: null })

            const transformedMids = response.data.map((mid: any) => ({
                label: mid.midName || mid.midCode || 'Unknown',
                value: mid.id,
            }));

            setMidOptions([{
                label: 'Reset',
                value: '',
            }, ...transformedMids]);

        } catch (e) {

        }
    }

    const handleSelectMid = async (value: string) => {
        try {
            setSelectedMID(value)
            const commissionsResponse = await apiService.getCommissionsByMidId(value);
            setCommissions(commissionsResponse.data);
        } catch (e) {

        }
    }

    const handlePageChange = async (newPage: number) => {
        const pageInfo: ApiPageInfo = {
            page: newPage - 1,
            size: 10
        }
        try {
            setTransactionsLoader(true)
            const response = await apiService.getTransactionsListForSettlement({
                startDate: dateService.formatDateTime(selectedFromDate!, selectedFromTime),
                endDate: dateService.formatDateTime(selectedToDate!, selectedToTime),
                merchantId: selectedMerchant,
                midId: selectedMID,
                statuses: [StatusType.APPROVED, StatusType.DECLINED]
            }, pageInfo)

            setTransactionsForSettle(response.data.content);
            setCurrentPage(newPage);
        } catch (e) {

        } finally {
            setTransactionsLoader(false)
        }
    }

    // const handleAddTransactions = (customTransactions: CustomTransaction[]) => {
    //     setAddTransactionModal(false)
    //     setAddedTransactions(prev => {
    //         const incomingIds = new Set(customTransactions.map(t => t.id));

    //         const filteredPrev = prev.filter(t => !incomingIds.has(t.id));

    //         return [...filteredPrev, ...customTransactions];
    //     });
    // }

    const handleAddTransaction = (customTransaction: CustomTransaction) => {
        setAddedTransactions(prev => {
            const exists = prev.some(t => t.id === customTransaction.id);

            if (exists) {
                return prev.filter(t => t.id !== customTransaction.id);
            } else {
                return [...prev, customTransaction];
            }
        });
    };

    const handleRemoveTransaction = () => {
        setRemoveTransactionModal(false)
        setAddedTransactions(prev => {
            return prev.filter((transaction) => transaction.id !== removeTransactionId)
        })
    }

    const handelDownload = async () => {
        if (selectedFromDate && selectedToDate) {
            const defaultTransactionFilters: Partial<TransactionFilters> = {
                startDate: dateService.formatDateTime(selectedFromDate, selectedFromTime),
                endDate: dateService.formatDateTime(selectedToDate, selectedToTime),
                merchantId: selectedMerchant,
                midId: selectedMID,
                statuses: [StatusType.APPROVED, StatusType.DECLINED]
            }

            const transformedTransactions = addedTransactions.map(({ selectedFee, ...rest }) => {
                const commission = commissions.find(c => c.id === selectedFee) || null;

                return {
                    transaction: rest,
                    commissions: [commission],
                };
            });

            try {
                setIsDownloading(true);


                const response = await apiService.generateSettlementReportExcelAndPDF({
                    defaultTransactionsFilters: defaultTransactionFilters,
                    excludedTransactions: excludedTransactions,
                    addedTransactions: transformedTransactions
                })

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'settlement.zip');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error: any) {
                if (error.code == 'ECONNABORTED') {
                    errorService.showError('Download failed', 'Please select a smaller interval');
                } else {
                    errorService.showApiError(error);
                }
            } finally {
                setIsDownloading(false);
            }
        }
    }

    return (
        <div className="generate-settlement-page page-content">
            <div className="page-header flex-row flex-gap-20 flex-align-start-center width-100 flex-wrap">
                <div className='page-title'>
                    Generate Settlement
                </div>
                <AppSelect
                    theme='filter'
                    options={merchantOptions}
                    value={selectedMerchant}
                    placeholder='Select Merchant'
                    onChange={(value) => {
                        setSelectedMerchant(value)
                        handleGetMids(value)
                    }}
                />

                <AppSelect
                    theme='filter'
                    options={midOptions}
                    value={selectedMID}
                    placeholder='Select MID'
                    onChange={(value) => { handleSelectMid(value) }}
                />
            </div>
            <div className='flex-row width-100 flex-align-space-between-center flex-wrap'>
                <div className='flex-column flex-align-start-start flex-wrap flex-gap-30'>
                    <div className='flex-row flex-align-start-end flex-gap-30 width-100'>
                        <AppDatePicker
                            value={selectedFromDate}
                            onChange={(newDate) => {
                                setSelectedFromDate(newDate);

                            }}
                            placeholder="Select DAY FROM"
                            shouldDisableDate={(date) =>
                                (selectedToDate && date.isAfter(selectedToDate, 'day')) || date.isAfter(dayjs(), 'day')
                            }
                        />
                        <div className='flex-column'>
                            <AppFormElementLabel name='selectedFromTime' label='Select Time From' id=''></AppFormElementLabel>
                            <AppTimePicker
                                value={selectedFromTime}
                                onChange={(value) => setSelectedFromTime(value)}
                            />
                        </div>
                    </div>
                    <div className='flex-row flex-align-start-end flex-wrap flex-gap-30'>
                        <AppDatePicker
                            value={selectedToDate}
                            onChange={(newDate) => {
                                setSelectedToDate(newDate);
                            }}
                            placeholder="Select DAY TO"
                            shouldDisableDate={(date) =>
                                (selectedFromDate && date.isBefore(selectedFromDate, 'day')) || date.isAfter(dayjs(), 'day')
                            }
                        />
                        <div className='flex-column'>
                            <AppFormElementLabel name='selectedToTime' label='Select Time To' id=''></AppFormElementLabel>
                            <AppTimePicker
                                value={selectedToTime}
                                onChange={(value) => setSelectedToTime(value)}
                            />
                        </div>
                    </div>
                </div>
                {isDownloading ? (
                    <div className="downloading-text flex-row flex-align-center">
                        <LoadingSpinner />
                    </div>
                ) : <Button
                    label='Confirm & Download'
                    onClick={() => handelDownload()}
                    disabled={!selectedFromDate || !selectedFromTime || !selectedToTime || !selectedFromDate || !selectedMerchant || !selectedMID}
                />
                }

            </div>

            <div className='inner-page flex-column flex-gap-30 width-100'>
                <div className='flex-row width-100 flex-align-space-between-center'>
                    <span className='total-elements'>Total elements: {totalElements}</span>
                    <span className='total-elements'>Total excluded elements: {excludedTransactions.length}</span>
                </div>
                <TableContent columns={columnsTransactions} data={transactionsForSettle || []} isLoading={transactionsLoader} />
                <TablePagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />
            </div>


            <div className='inner-page flex-column flex-gap-30 width-100'>
                <div className='flex-row width-100 flex-align-space-between-center'>
                    <span className='total-elements'>Total elements: {addedTransactions.length}</span>
                    <Button label='Add More' theme='accent' onClick={() => { setAddTransactionModal(true) }} />
                </div>
                <TableContent columns={columnAddedTransactions} data={addedTransactions || []} />
            </div>


            {addTransactionsModal && <AddCustomTransactionsModal
                addedTransactions={addedTransactions}
                commissionsOptions={commissionsOptions}
                merchantId={selectedMerchant}
                midId={selectedMID}
                setAddedTransaction={setAddedTransactions}
                handleCancel={() => setAddTransactionModal(false)}
                handleSubmit={() => setAddTransactionModal(false)}
                addSingleTransaction={handleAddTransaction}
            />}

            {removeTransactionModal && <Modal
                message={`Are you sure you want to remove transaction: ${removeTransactionId}`}
                onCancel={() => setRemoveTransactionModal(false)}
                showCancelButton
                buttonText='Remove'
                onSubmit={() => handleRemoveTransaction()}
            >
            </Modal>

            }


        </div>
    )
}

export default GenerateSettlementPage;